module.exports = __webpack_public_path__ + "img/baoming.1630993415105.png";